import { render, staticRenderFns } from "./amountPaid.vue?vue&type=template&id=58709f55&scoped=true"
import script from "./amountPaid.vue?vue&type=script&lang=js"
export * from "./amountPaid.vue?vue&type=script&lang=js"
import style0 from "./amountPaid.vue?vue&type=style&index=0&id=58709f55&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58709f55",
  null
  
)

export default component.exports